
import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import ExtraServiceSelect from "@/components/inputs/ExtraServiceSelect.vue";
import Budget from '../../models/budget';
import {CambiosAlGuardar, sinCambios} from '@/helpers/ventana-al-guardar';

@Component({
	components: {
		ExtraServiceSelect,
	},
})
export default class TabBudgetExtraServices extends Vue {
	@Prop({ default: null, required: true }) private budget;
	// M-13: días naturales del viaje. Los necesita ExtraServiceSelect para multiplicar
	// las tarifas «por día»; sin declararla, la prop que ya envía CustomerBudgetForm se
	// quedaría en $attrs y nunca llegaría al selector.
	@Prop({ default: 0, required: false }) private days;
	// M-15: pasajeros del viaje (alumnos + profesores). Mismo motivo que `days`:
	// sin declararla, la prop se quedaría en $attrs y el selector no repartiría.
	@Prop({ default: 0, required: false }) private people;
	// N-234: las unidades contratadas de cada servicio extra. Mismo motivo que `days`
	// y `people`: sin declararla, la prop que ya envía CustomerBudgetForm se quedaría
	// en $attrs y el selector no pintaría la cantidad ni la multiplicaría.
	@Prop({ default: null, required: false }) private quantities;
	// N-287 C1: la llegada del viaje (a uno ya empezado no se le aplica el tramo) y C2: el rechazo
	// del servidor. Mismo motivo que `days`: sin declararlas, no llegarían al selector.
	@Prop({ default: null, required: false }) private start_date;
	@Prop({ default: null, required: false }) private errores_servidor;
	@Prop({ default: null, required: false }) private errors;

	private extra_service_budget: any;

	constructor() {
		super();
		this.extra_service_budget = new Budget();
	}

	mounted() {
		if (this.budget) {
			this.extra_service_budget = Budget.copy(this.budget);
		}
	}

	$refs!: {
		extraServiceSelect: InstanceType<typeof ExtraServiceSelect>;
	};

	setPrice(value){
		this.$emit('setPrice', value);
		this.$emit("input", this.extra_service_budget.extra_service);
	}

	// N-234: la cantidad sube hasta el formulario, que es quien guarda el presupuesto.
	// No viaja por `input` —ese canal es el array de opciones marcadas, cuya forma es la
	// identidad de las casillas— sino por su propio evento, como el precio.
	setQuantity(quantities){
		this.$emit('setQuantity', quantities);
	}

	// N-235: las plazas de profesor que ocupan los extras marcados (el coordinador),
	// hasta el formulario, que las suma al recargo de profesores del total en vivo.
	setSeats(seats){
		this.$emit('setSeats', seats);
	}

	// N-287 C1: lo que el cambio de pasajeros quitó, hacia arriba (lo enseñaba el salto de GUARDAR, que
	// ahora sustituye la ventana de N-288 T3; el aviso sigue subiendo por si alguien lo escucha).
	setQuitados(quitados){
		this.$emit('setQuitados', quitados);
	}

	// N-288 · T3: lo que el cambio de pasajeros quitó o pasó a otra tarifa, para la ventana de GUARDAR.
	cambiosAlGuardar(): CambiosAlGuardar {
		return this.$refs.extraServiceSelect ? this.$refs.extraServiceSelect.cambiosAlGuardar() : sinCambios();
	}

	async validate() {
		this.$refs.extraServiceSelect.setPrice();
		this.$emit("input", this.extra_service_budget.extra_service);
		return true;
	}
}
